import cn from 'classnames';
import { Icon } from '@/shared/IconCollecion';
import { CheckBoxColor } from '@/shared/types/icons';

type CheckboxMarkProps = {
  isChecked: boolean;
  color?: CheckBoxColor;
  className?: string;
};

const CheckboxMark = ({ isChecked, color, className }: CheckboxMarkProps) => {
  const checkmarkColorClass = color === 'gray' ? 'text-gray-950' : 'text-white';

  return (
    <div className={cn('flex-0 mb-auto flex size-6', checkmarkColorClass, className)}>
      <Icon
        name="Checkbox_On"
        color={color}
        className={cn('h-full w-full', !isChecked && 'hidden')}
      />

      <Icon
        name="Checkbox_Off"
        color={color}
        className={cn('h-full w-full', isChecked && 'hidden')}
      />
    </div>
  );
};

export { CheckboxMark };
